import React, { useContext } from "react";

import AnswersContext from "../contexts/AnswersContext";

import {
  unansweredQuestions,
  correctQuestions,
  incorrectQuestions,
} from "../Data";

const AnswerBadges = ({ category, topic }) => {
  const { answers } = useContext(AnswersContext);

  const unanswered = unansweredQuestions(answers, category, topic).length;
  const correct = correctQuestions(answers, category, topic).length;
  const incorrect = incorrectQuestions(answers, category, topic).length;

  return (
    <span className="text-nowrap">
      <span className="badge fs-6 bg-primary rounded-pill" aria-hidden="true">
        {unanswered}
      </span>
      <span className="visually-hidden">{unanswered} unanswered,</span>

      <span className="badge fs-6 bg-success rounded-pill" aria-hidden="true">
        {correct}
      </span>
      <span className="visually-hidden">{correct} correct,</span>

      <span className="badge fs-6 bg-danger rounded-pill" aria-hidden="true">
        {incorrect}
      </span>
      <span className="visually-hidden">{incorrect} incorrect.</span>
    </span>
  );
};

export default AnswerBadges;
